import React, { createContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { findAll } from "../../services/groupItemService";

export const GroupItemContext = createContext({
  dataList: null,
  data: null,
  isLoadingDataList: false,
  isDrawerVisible: false,
  options: [],
  isLoadingOptions: false,
  lastSaved: null,
});

export const GroupItemContextProvider = ({ children }) => {
  const [dataList, setDataList] = useState(null);
  const [data, setData] = useState(null);
  const [isLoadingDataList, setIsLoadingDataList] = useState(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [options, setOptions] = useState([]);
  const [isLoadingOptions, setIsLoadingOptions] = useState(false);
  const [lastSaved, setLastSaved] = useState(null);

  const {
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const fetchData = useCallback(
    async (pagination = {}) => {
      setIsLoadingDataList(true);
      try {
        const {
          data: { results },
        } = await findAll({ groupId, farmId, ...pagination });
        setDataList(results);
      } catch (error) {
      } finally {
        setIsLoadingDataList(false);
      }
    },
    [groupId, farmId]
  );

  const fetchOptions = useCallback(async () => {
    setIsLoadingOptions(true);
    try {
      const {
        data: { results },
      } = await findAll({ groupId, farmId, size: 1000 });
      setOptions(Array.isArray(results) ? results : (results?.content ?? []));
    } catch (error) {
      setOptions([]);
    } finally {
      setIsLoadingOptions(false);
    }
  }, [groupId, farmId]);

  const notifySaved = useCallback((entity) => {
    setLastSaved(entity);
  }, []);

  const openDrawer = useCallback((record = null) => {
    if (record) setData(record);
    setIsDrawerVisible(true);
  }, []);

  const closeDrawer = useCallback(() => {
    setData(null);
    setIsDrawerVisible(false);
  }, []);

  return (
    <GroupItemContext.Provider
      value={{
        dataList,
        data,
        isLoadingDataList,
        isDrawerVisible,
        options,
        isLoadingOptions,
        lastSaved,
        fetchData,
        fetchOptions,
        notifySaved,
        openDrawer,
        closeDrawer,
      }}
    >
      {children}
    </GroupItemContext.Provider>
  );
};
